import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  MAP_FLOOR_PAGE_ADD_PATH,
  MAP_FLOOR_PAGE_PATH,
  MAP_FLOOR_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const MapFloorPage = Loadable(React.lazy(() => import("./View")));
const MapFloorPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const MapFloorRoute: IRouteItem = {
  path: MAP_FLOOR_PAGE_PATH,
  element: React.createElement(MapFloorPage),
  name: "Map Floors",
  children: [
    {
      name: "Add / Update",
      path: MAP_FLOOR_PAGE_ADD_PATH,
      element: React.createElement(MapFloorPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: MAP_FLOOR_PAGE_UPDATE_PATH,
      element: React.createElement(MapFloorPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
